/**
 * Türkçe arama için metin normalizasyonu.
 * "TEKIN".toLocaleLowerCase('tr-TR') → "tekın" olduğundan
 * "teki" ile eşleşmez; ı/i ve diğer Türkçe harfler birleştirilir.
 */
export function normalizeForSearch(value) {
  if (value == null) return '';
  return String(value)
    .toLocaleLowerCase('tr-TR')
    .replace(/\u0130/g, 'i') // İ
    .replace(/\u0069\u0307/g, 'i') // i + combining dot
    .replace(/ı/g, 'i')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c');
}

export function searchIncludes(haystack, needle) {
  if (!needle) return true;
  return normalizeForSearch(haystack).includes(normalizeForSearch(needle));
}
